/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconEscapeViolence extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "EscapeViolenceIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><g><path fill="#ffcc80" d="M58.19,34.88a5.56,5.56,0,0,0-2.33-3.7,5.25,5.25,0,0,0-4-1,5.56,5.56,0,0,0-3.71,2.35l-1.9,2.72L41.51,8.54A4.27,4.27,0,1,0,33.1,10L36,26.12c0,.23,0,.32-.25.36s-.32,0-.36-.25l-3.53-20a4.27,4.27,0,1,0-8.41,1.49l3.53,20c0,.23,0,.32-.25.36a.35.35,0,0,1-.25,0,.35.35,0,0,1-.11-.23L23.26,10.44a4.27,4.27,0,1,0-8.41,1.49l3.08,17.38c0,.23,0,.32-.25.36s-.32,0-.36-.25l-1.71-9.66A4.27,4.27,0,1,0,7.2,21.25l5.36,30.26A11.51,11.51,0,0,0,23.84,61a11.53,11.53,0,0,0,2-.18l14.42-2.55a9.8,9.8,0,0,0,5.82-3.36l.11.08,11-16.06A5.26,5.26,0,0,0,58.19,34.88Z"></path><polygon fill="#f44336" points="53.31 31.45 47.13 27.13 51.42 21 47.67 18.38 43.38 24.51 37.23 20.21 34.61 23.96 40.76 28.26 36.43 34.45 40.18 37.07 44.51 30.88 50.69 35.2 53.31 31.45"></polygon></g></svg>
    `;
}
